import { useRef } from "react";
const useClickAwayCallback = (cb, targetCount = 2) => {
  const refs = useRef({ counter: 0 });
  return () => {
    refs.current.counter++, refs.current.counter === targetCount && cb(), window.setTimeout(() => {
      refs.current.counter = 0;
    });
  };
};
export {
  useClickAwayCallback
};
//# sourceMappingURL=useClickAwayCallback.js.map
